import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Box,
  Grid,
  InputAdornment,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import { clearState } from "store/reducers/accounts";
import * as yup from "yup";

const validation = yup.object({
  username: yup.string("Enter username").required("Username required"),
  password: yup.string("Enter password").required("Password required"),
  passwordConfirmation: yup
    .string("Repeat password")
    .oneOf([yup.ref("password"), null], "Passwords must match"),
  email: yup.string().email("Enter email"),
  phone: yup.string("Phone").length(10),
});

function AccountsCreateForm({ mod, callback }) {
  useEffect(() => {
    dispatch(clearState());
  }, []);

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      passwordConfirmation: "",
      email: "",
      phone: "",
    },
    validationSchema: validation,
    onSubmit: (data) => {
      const new_data = { ...data };
      if (data.email.length === 0) {
        new_data.email = null;
      }
      if (data.phone.length === 0) {
        new_data.phone = null;
      } else {
        new_data.phone = `+91${new_data.phone}`;
      }
      callback(new_data);
    },
  });

  const isFullWidth = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const accountsState = useSelector((state) => state.accounts);

  useEffect(() => {
    console.log(accountsState.errorMessageCreate);
    if (accountsState.errorMessageCreate) {
      Object.keys(accountsState.errorMessageCreate).forEach((key) => {
        console.log(key, accountsState.errorMessageCreate[key][0]);
        formik.setFieldError(key, accountsState.errorMessageCreate[key][0]);
      });
    }
  }, [accountsState.errorMessageCreate]);
  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container columnSpacing={2} rowSpacing={0}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Username"
              variant="outlined"
              name="username"
              fullWidth
              sx={{ mt: 3 }}
              value={formik.values.username}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.username)}
              helperText={formik.errors.username}
              autoComplete="new-password"
              required
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Password"
              variant="outlined"
              name="password"
              type="password"
              autoComplete="new-password"
              fullWidth
              sx={{ mt: 3 }}
              value={formik.values.password}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.password)}
              helperText={formik.errors.password}
              required
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Repeat password"
              variant="outlined"
              name="passwordConfirmation"
              type="password"
              autoComplete="new-password"
              fullWidth
              sx={{ mt: 3 }}
              value={formik.values.passwordConfirmation}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.passwordConfirmation)}
              helperText={formik.errors.passwordConfirmation}
              required
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Email"
              variant="outlined"
              name="email"
              type="email"
              autoComplete="new-password"
              fullWidth
              sx={{ mt: 3 }}
              value={formik.values.email}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.email)}
              helperText={formik.errors.email}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Phone"
              name="phone"
              type="phone"
              autoComplete="new-password"
              fullWidth
              sx={{ mt: 3 }}
              value={formik.values.phone}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.phone)}
              helperText={formik.errors.phone}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">+91</InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>

        {accountsState.errorCreate && (
          <Alert sx={{ mt: 3 }} severity="error">
            Error occurred
          </Alert>
        )}
        {accountsState.successCreate && (
          <Alert sx={{ mt: 3 }} severity="success">
            Success
          </Alert>
        )}
        <LoadingButton
          loading={accountsState.loadingCreate}
          variant="contained"
          fullWidth={isFullWidth}
          sx={{ mt: 3 }}
          type="submit"
        >
          {`Create ${mod}`}
        </LoadingButton>
      </form>
    </Box>
  );
}

export default AccountsCreateForm;
